// Copyright (c) 2025 by Audere

import { LabelData } from "../features/api/labelApiSlice";

export const getTaskLabels = (
  taskID: string,
  existingLabels: LabelData[] | undefined,
  messageUID?: string
) => {
  return messageUID
    ? existingLabels?.find(
        (label: LabelData) =>
          label.labeling_task === taskID && label.message_uid === messageUID
      )
    : existingLabels?.find(
        (label: LabelData) => label.labeling_task === taskID
      );
};
